// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CFLpz","field":"styles_field__3M5EG","fieldCol":"styles_fieldCol__2b96J","diffCol":"styles_diffCol__V3Bop","diff":"styles_diff__2wSg6"};